import { render, staticRenderFns } from "./style-transfer.vue?vue&type=template&id=96c9c304&scoped=true&"
import script from "./style-transfer.vue?vue&type=script&lang=js&"
export * from "./style-transfer.vue?vue&type=script&lang=js&"
import style0 from "./style-transfer.vue?vue&type=style&index=0&id=96c9c304&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c9c304",
  null
  
)

export default component.exports